import React from 'react'

export default function Footer() {
    return (
        <div style={{marginBottom: "100px"}}>
            
        </div>
    )
}
